export const deployInfo = {
  shortSha: 'e6f7b30',
  commitSha: 'e6f7b30f43e42f468efb21aa3a7bce6dba27a17b',
  rollbar: { webPostToken: '0ba6e92852d34daca1cfa9d0ca291a82' }
}
